module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-detail-box"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.back
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.name))])]), _vm._v(" "), _c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "content-copy"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "content-box-copy",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n              共" + _vm._s(_vm.sum) + "个产品  "), _c('span', {
    staticClass: "higlight"
  }, [_vm._v("企业产品:" + _vm._s(_vm.company) + ",已过期产品:" + _vm._s(_vm.expired))])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "height": "auto"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "名称",
      "min-width": "220",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typename",
      "label": "类型",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usingstatusname",
      "label": "状态",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.usingstatus == 1) ? _c('span', {
          staticStyle: {
            "color": "#2196f3"
          }
        }, [_vm._v(_vm._s(scope.row.usingstatusname))]) : _c('span', [_vm._v(_vm._s(scope.row.usingstatusname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duetime",
      "label": "到期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.duetime.split(" ")[0]) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [(scope.row.usingstatus == 1) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "禁用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondisabled",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.usingstatus == 3) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "启用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconaccomplish",
          on: {
            "click": function($event) {
              return _vm.handleOpen(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "content-box-two-copy",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登录日历")]), _vm._v(" "), _c('Calendar')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-copy"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "content-box-copy"
  }, [_c('LeftCharts', {
    attrs: {
      "userid": _vm.$route.query.userId
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "content-box-two-copy"
  }, [_c('RightCharts', {
    attrs: {
      "userid": _vm.$route.query.userId
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.showRecords ? 'content-copy' : 'newstyle'
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.showRecords ? 16 : 24
    }
  }, [_c('div', {
    class: _vm.showRecords ? 'newstyle' : ''
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户备注")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "rows": 3,
      "type": "textarea",
      "placeholder": "填写留言"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addUserNote
    }
  }, [_vm._v("提交")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#616161",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n              所有备注(" + _vm._s(_vm.allcount) + ")\n            ")]), _vm._v(" "), _vm._l((_vm.notes), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contextx"
    }, [_c('div', {
      staticClass: "contexss",
      staticStyle: {
        "height": "30px"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "width": "80px",
        "float": "left",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "margin-left": "20px",
        "float": "left",
        "color": "#acabab"
      }
    }, [_vm._v(_vm._s(item.intime))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "contexss",
      staticStyle: {
        "color": "#707070"
      }
    }, [_vm._v("\n                " + _vm._s(item.note) + "\n              ")])])
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "0.5px solid #d4d3d3"
    }
  })], 2)]), _vm._v(" "), (_vm.showRecords) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loginInfoLoading),
      expression: "loginInfoLoading"
    }],
    staticClass: "content-box-two-copy"
  }, [_c('div', {
    staticClass: "record_title"
  }, [_vm._v("登录记录统计")]), _vm._v(" "), _c('div', {
    staticClass: "login_info"
  }, [_c('span', {
    staticClass: "login_title"
  }, [_vm._v("总计登录："), _c('span', {
    staticClass: "login_num"
  }, [_vm._v(_vm._s(_vm.countNum) + "次")])])]), _vm._v(" "), _c('div', {
    staticClass: "last_time"
  }, [_vm._v("\n              您上次登陆时间和位置：" + _vm._s(_vm.lastLogin_time) + "，" + _vm._s(_vm.lastLogin_location) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "history"
  }, [_vm._v("历史记录（最近10次）")]), _vm._v(" "), _vm._l((_vm.infos), function(item) {
    return _c('div', {
      staticClass: "history_item"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('span', {
      staticClass: "times"
    }, [_vm._v(_vm._s(item.times))]), _vm._v(" "), _c('span', {
      staticClass: "ip"
    }, [_vm._v(_vm._s(item.ip))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.location))])])
  })], 2)]) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b439a1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/userDetail.vue
// module id = 1759
// module chunks = 9